import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import type { FunctionComponent, SuspenseProps } from "react";
import { useEffect, useState } from "react";

import { appAtom } from "scmp-app/lib/app/atoms";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import { pathname as homepagePathname } from "scmp-app/pages/plus";
import { pathname as plusLearnMorePathname } from "scmp-app/pages/plus/learnmore/index";

export const PlusLearnMoreSuspense: FunctionComponent<SuspenseProps> = ({ children, ...props }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const hasScmpPlusAccessRight = asyncRosettaState?.result?.hasScmpPlusAccessRight ?? false;
  const router = useRouter();
  const { navigatorInfo } = useAtomValue(appAtom);
  const isLightHouseCrawler = navigatorInfo?.isLightHouseCrawler;

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  if (
    plusLearnMorePathname === router.pathname ||
    homepagePathname === router.pathname ||
    isLightHouseCrawler
  ) {
    return children;
  }
  if (asyncRosettaState?.status !== "success" || !hasScmpPlusAccessRight) {
    return props.fallback;
  }
  return children;
};

PlusLearnMoreSuspense.displayName = "PlusLearnMoreSuspense";
